import React, { useEffect, useState } from 'react';
import { Box, Button, Container, Grid, Paper, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Placeholder, Subheader, TextInput } from 'components';
import { Check } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import { useAlerts, useSubmissions, useTrainingPlanDrills } from 'hooks';

const useStyles = makeStyles((theme) => ({
	itemContainer: {
		padding: theme.spacing(2),
		borderBottom: `1px solid ${theme.palette.grey[300]}`,
		height: 400
	},
	placeholder: {
		color: theme.palette.text.secondary
	}
}));

const TrainingPlanDrillSubmissionNew = () => {
	const { id, drillId } = useParams();

	const [feedback, setFeedback] = useState({
		comment: '',
		skill_ratings: {}
	});
	const { trainingPlanDrill, findTrainingPlanDrill, createFeedback } =
		useTrainingPlanDrills({ id: drillId });
	const { findSubmission, submission } = useSubmissions({
		url: `/api/v1/admin/training_plan_drills/${drillId}/submissions`
	});
	const { showAlertError, showAlertSuccess } = useAlerts();
	const navigate = useNavigate();

	const classes = useStyles();

	const handleSaveClick = async () => {
		const response = await createFeedback(drillId, {
			...feedback,
			submission_id: id
		});

		if (response.status === 'sent') {
			showAlertSuccess('Feedback sent successfully');
		} else {
			showAlertError('Error sending feedback');
		}

		navigate(`/training-plan-drills/${drillId}`);
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFeedback({ ...feedback, [name]: value });
	};

	const handleSkillScoreChange = (e, skill) => {
		const { name, value } = e.target;
		setFeedback({
			...feedback,
			skill_ratings: { ...feedback.skill_ratings, [skill.toLowerCase()]: value }
		});
	};

	useEffect(() => {
		if (id) findSubmission(id);
	}, [id]);

	useEffect(() => {
		if (drillId) findTrainingPlanDrill(drillId);
	}, [drillId]);

	return (
		<>
			<Subheader
				title="Give Feedback"
				buttons={[
					<Button
						color="primary"
						variant="contained"
						startIcon={<Check />}
						onClick={handleSaveClick}
					>
						Save
					</Button>
				]}
			/>

			<Container>
				<Paper>
					<Box p={4}>
						<Grid container>
							<Grid className={classes.itemContainer} item xs={12} md={6}>
								<center className={classes.placeholder}>
									<Typography variant="caption">Benchmark Video</Typography>
								</center>
								<video
									width="100%"
									height={'90%'}
									controls
									src={trainingPlanDrill?.lesson?.video_url}
								/>
							</Grid>
							<Grid className={classes.itemContainer} item xs={12} md={6}>
								<center className={classes.placeholder}>
									<Typography variant="caption">
										Users Uploaded Attempt
									</Typography>
								</center>
								<video
									width="100%"
									height={'90%'}
									controls
									src={submission?.video_url}
								/>
							</Grid>
						</Grid>

						<Grid item xs={12} sm={12}>
							<Box sx={{ marginTop: 20 }}>
								<Typography variant="h5">Feedback</Typography>
								<TextInput
									value={feedback.comment || ''}
									label=""
									name="comment"
									placeholder="Feedback"
									handleChange={handleChange}
									type={'text'}
									multiline={true}
									rows={10}
								/>
							</Box>

							{trainingPlanDrill?.category_names?.map((skill, index) => (
								<Box sx={{ marginTop: 20 }} key={index}>
									<Typography variant="h5">{skill}</Typography>
									<TextInput
										key={index}
										value={feedback.skill_ratings[skill.toLowerCase()] || ''}
										label={skill}
										name={skill.toLowerCase()}
										placeholder={skill}
										handleChange={(e) => handleSkillScoreChange(e, skill)}
										type={'number'}
									/>
								</Box>
							))}
						</Grid>
						<Box py={2}>
							<Button
								color="primary"
								variant="contained"
								startIcon={<Check />}
								onClick={handleSaveClick}
							>
								Save
							</Button>
						</Box>
					</Box>
				</Paper>
			</Container>
		</>
	);
};

export default TrainingPlanDrillSubmissionNew;
